import { ComponentProps } from "react";
import { useSetPageParam } from "@hooks/useSetPageParam";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";

type MoreVideosCardProps = {
  /** This is the video to be displayed. */
  video: ComponentProps<typeof Card>;
  /** This is the index of the video. */
  index: number;
};

/** This is the component for displaying the more videos card. */
const MoreVideosCard = ({
  video,
  index,
}: MoreVideosCardProps): React.ReactElement => {
  const { ref } = useSetPageParam({ cardIndex: index });

  const variant: CardVariations = {
    image: {
      isVideo: true,
      position: "left",
      width: "w-120px lg:w-1/4",
      aspectRatio: "aspect-video",
    },
    content: {
      width: "w-full-120px lg:w-3/4",
      extraClass: "pl-4",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
      extraClass: "font-lct",
    },
  };

  return <Card {...video} variations={variant} ref={ref} />;
};

export default MoreVideosCard;
